import { useTribalContext } from '@/context/tribal';
import {
  Text,
  TextTag,
  TokenTextAppearance,
  DesignTokenSizeEnum,
} from '@volkswagen-onehub/components-core';
import Box from '@/modules/components/Box/Box';
import CTACardCarousel from '@/modules/features/single/CTACardCarousel/CTACardCarousel';
import { getCTACardSlidesPerPage } from '@/modules/utils/storeUtils';

function GoingHybrid() {
  const { contentManager } = useTribalContext();
  const totalSlides = parseInt(
    contentManager.get('going-hybrid-section-slides-total')
  );

  let goingHybridSlidesData: any[] = [];

  for (let i = 1; i <= totalSlides; i++) {
    const title = contentManager.get(`going-hybrid-section-slide-${i}-title`);
    const image = contentManager.get(`going-hybrid-section-slide-${i}-image`);
    const text = contentManager.get(`going-hybrid-section-slide-${i}-text`);
    const linkUrl = contentManager.get(
      `going-hybrid-section-slide-${i}-link-url`
    );
    const linkText = contentManager.get(
      `going-hybrid-section-slide-${i}-link-text`
    );

    goingHybridSlidesData.push({
      title,
      image: {
        desktopUrl: image,
      },
      text,
      linkCtaLabel: linkText,
      onClick: () => {
        window.open(linkUrl, '_blank');
      },
    });
  }

  const { slidesPerPage, hideNavigation } = getCTACardSlidesPerPage(
    goingHybridSlidesData.length
  );

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        gap={DesignTokenSizeEnum.static250}
        mb={DesignTokenSizeEnum.static350}
        b960={{ mb: DesignTokenSizeEnum.static515 }}
      >
        <Text tag={TextTag.h2} appearance={TokenTextAppearance.headline300}>
          {contentManager.get('going-hybrid-section-title-normal')}
          <strong>
            {' '}
            {contentManager.get('going-hybrid-section-title-bold')}
          </strong>
        </Text>
        <Text appearance={TokenTextAppearance.bigcopy100}>{contentManager.get('going-hybrid-section-subtitle')}</Text>
      </Box>
      <CTACardCarousel
        bulletPrefix="Going hybrid?"
        ctaCardData={goingHybridSlidesData}
        id="going-hybrid-carousel"
        ariaLabel="Going hybrid carousel"
        slidesPerPage={slidesPerPage}
        hideNavigationDesktop={hideNavigation}
      />
    </>
  );
}

export default GoingHybrid;
